import axios from "axios";
import {appConfig} from "config/defaultConfig";
import {AUTO_ENRICHMENT_SOURCE} from "models/constants";
import {SAVED_INVESTIGATIONS_FILTER_SORT_DEFAULT} from "models/options";
import {getShortId} from "utils/misc";
import {extractXHitsHeader} from "./utils/incidents";

const EXCLUDE_AUTO_ENRICHED = `AND NOT source:"${AUTO_ENRICHMENT_SOURCE}"`;

export function fetchSnapshots({searchText, page, pageCount, order, orderBy}) {
  const defaultOrder = SAVED_INVESTIGATIONS_FILTER_SORT_DEFAULT.order;
  const defaultOrderBy = SAVED_INVESTIGATIONS_FILTER_SORT_DEFAULT.orderBy;
  const params = {
    query: searchText
      ? `${searchText} ${EXCLUDE_AUTO_ENRICHED}`
      : `* ${EXCLUDE_AUTO_ENRICHED}`,
    sort_order: order ? order.toLowerCase() : defaultOrder.toLowerCase(),
    sort_by: orderBy ? orderBy.toLowerCase() : defaultOrderBy.toLowerCase(),
    offset: page ? (page - 1) * pageCount : 0,
    limit: pageCount,
    fields: ["source", "short_description", "id", "timestamp", "description"]
  };

  return axios
    .get(
      // eslint-disable-next-line max-len
      `${window.CONFIG.privateCtiaUrl}${appConfig.APP.CTIA_SERVICES.ROUTES.SAVED_INVESTIGATION_SEARCH}`,
      {params}
    )
    .then((response) => {
      return {
        dataRows: response.data,
        totalRows: extractXHitsHeader(response),
        searchText,
        page: params.offset
      };
    });
}

export function deleteSnapshots(selectedRows) {
  const promises = selectedRows.map((row) => {
    const shortId = getShortId(row.id);
    return axios.delete(
      // eslint-disable-next-line max-len
      `${window.CONFIG.privateCtiaUrl}${appConfig.APP.CTIA_SERVICES.ROUTES.INVESTIGATION}/${shortId}`
    );
  });
  return Promise.all(promises);
}
